import { DEFAULT_HOURLY_RATE_TYPE, normalizeTypStawkiGodzinowej } from '@/shared/hourlyRateTypes'
import { createEmptyContentItem } from './normalizeContentItems'
import { normalizeCertificates } from './normalizeCertificates'

export const createEmptyPozycja = (defaults = {}) => ({
	...createEmptyContentItem(),
	trainerId: null,
	trainerName: '',
	miasto: '',
	odleglosc_km: '',
	odleglosc_z_domu_km: '',
	odleglosc_z_poprzedniej_placowki_km: '',
	odleglosc_drogi_google_km: '',
	typ_stawki_godzinowej: DEFAULT_HOURLY_RATE_TYPE,
	stawka_godzinowa: '',
	stawka_za_kilometr: 1,
	ilosc_godzin: '',
	do_wyplaty: '',
	inne_koszty: [],
	rozliczono: false,
	uwagi: '',
	certificates: normalizeCertificates(defaults.certificates),
})

export const clonePozycja = source => {
	if (!source || typeof source !== 'object') {
		return createEmptyPozycja()
	}

	const { _id, id, ...rest } = source
	return {
		...createEmptyPozycja(),
		...rest,
		odleglosc_km: 0,
		certificates: normalizeCertificates(source.certificates).map(item => ({ ...item })),
		inne_koszty: (Array.isArray(source.inne_koszty) ? source.inne_koszty : []).map(item => ({
			...item,
			_id: `trainer-cost-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
		})),
	}
}

export const normalizePozycje = (value, { keepEmpty = false, fallbackCertificates = [] } = {}) => {
	if (!Array.isArray(value)) {
		if (typeof value === 'string' && value.trim()) {
			try {
				return normalizePozycje(JSON.parse(value), { keepEmpty, fallbackCertificates })
			} catch {
				return []
			}
		}
		return []
	}

	const inheritedCertificates = normalizeCertificates(fallbackCertificates)

	return value
		.map(item => {
			if (!item || typeof item !== 'object') return null

			const itemCertificates = normalizeCertificates(item.certificates)
			const rawValue = `${item.value ?? item.name ?? item.label ?? ''}`
			const rawUwagi = `${item.uwagi ?? item.remarks ?? ''}`
			const normalized = {
				_id: item._id || item.id || undefined,
				// Keep raw text while editing (keepEmpty) so spaces are not stripped mid-typing.
				value: keepEmpty ? rawValue : rawValue.trim(),
				start_time: `${item.start_time ?? item.startTime ?? ''}`.trim(),
				end_time: `${item.end_time ?? item.endTime ?? ''}`.trim(),
				trainerId: item.trainerId || null,
				trainerName: `${item.trainerName || ''}`.trim(),
				miasto: `${item.miasto || ''}`.trim(),
				odleglosc_km: item.odleglosc_km ?? '',
				odleglosc_z_domu_km: item.odleglosc_z_domu_km ?? '',
				odleglosc_z_poprzedniej_placowki_km: item.odleglosc_z_poprzedniej_placowki_km ?? '',
				odleglosc_drogi_google_km: item.odleglosc_drogi_google_km ?? '',
				typ_stawki_godzinowej: normalizeTypStawkiGodzinowej(item.typ_stawki_godzinowej),
				stawka_godzinowa: item.stawka_godzinowa ?? '',
				stawka_za_kilometr: item.stawka_za_kilometr ?? 1,
				ilosc_godzin: item.ilosc_godzin ?? '',
				do_wyplaty: item.do_wyplaty ?? '',
				inne_koszty: Array.isArray(item.inne_koszty) ? item.inne_koszty : [],
				rozliczono: item.rozliczono === true || item.rozliczono === 'true',
				uwagi: keepEmpty ? rawUwagi : rawUwagi.trim(),
				certificates: itemCertificates.length ? itemCertificates : inheritedCertificates,
			}

			const isBlank = !normalized.value.trim()
				&& !normalized.start_time
				&& !normalized.end_time
				&& !normalized.trainerId
				&& !normalized.trainerName
				&& !normalized.certificates.length

			if (!keepEmpty && isBlank) return null
			return normalized
		})
		.filter(Boolean)
}
